import {UrlParamsService} from '../../../core/services/impl/url-params.service';
import {PartnerService} from '../../services/partner.service';
import {isSkycash} from '../../../core/utils/utils';

export class NotificationBase {

    urlParamsService: UrlParamsService;
    partnerService: PartnerService;

    get anchorButton(): boolean {
        return isSkycash() && this.urlParamsService.isMobileOrigin;
    }

    get redirectUrl(): string {
        if (isSkycash()) {
            return this.partnerService.skyCashExitActionUrl;
        }
        return null;
    }

    constructor(urlParamsService: UrlParamsService,
                partnerService: PartnerService) {
        this.urlParamsService = urlParamsService;
        this.partnerService = partnerService;
    }
}
